// propsで中身の要素を受け取るため、単体では使えないFrame的なコンポーネント。
// Moduleと依存関係が高いのでFrameディレクトリからは出しておく。

import { Component } from 'react';
import styled from 'styled-components';

/* 「もっと見る」+「全カテゴリのトピックス一覧」のラッパー */
const TopicsListButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

interface IProps {
  main: JSX.Element | JSX.Element[];
  button: JSX.Element | JSX.Element[];
  titleCategory?: JSX.Element | JSX.Element[];
}
/*
 * トピックスリスト系モジュール共通の親要素
 */
export default class TopicsListFrame extends Component<IProps> {
  /**
   *
   */
  public render() {
    const title = this.props.titleCategory ? this.props.titleCategory : null;

    return (
      <div>
        {title}
        <ul>{this.props.main}</ul>
        <TopicsListButtonWrapper>{this.props.button}</TopicsListButtonWrapper>
      </div>
    );
  }
}
